import './index.css';
import Battle from './Battle';

function App() {
  return (
    <div className="App">
      <Battle />
    </div>
  );
}

export default App;
